import { Fragment, useEffect, useState, useContext } from "react";
import { ColorPicker, useColor } from "react-color-palette";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useUserState, UserContext } from "../../../Contexts/UserContext";
import Button from "../../common/LoadingButton";
import "react-color-palette/css";

const ProductForm = () => {
  const { user } = useUserState();
  const navigate = useNavigate();
  const location = useLocation();
  const { categoryId, packageId, leasePeriod, categoryName } = location.state || {};
  const { furEditData, setFurEditData } = useContext(UserContext);

  const [inputData, setInputData] = useState({
    furnitureName: furEditData?.name ? furEditData?.name : "",
    furnitureCat: furEditData?.furniture_category_id
      ? furEditData?.furniture_category_id
      : categoryId,
    furniturePrice: furEditData?.price ? furEditData?.price : "",
    furnitureMaterial: furEditData?.material ? furEditData?.material : "",
    furnitureBrand: furEditData?.brand ? furEditData?.brand : "",
    furnitureDes: furEditData?.description ? furEditData?.description : "",
    houseware_categories: furEditData?.houseware_categories ? furEditData?.houseware_categories : "",
  });

  const [inputError, setInputError] = useState(false);
  const [urlData, setUrlData] = useState(
    furEditData?.furniture_images ? furEditData?.furniture_images : []
  );
  const [imgName, setImgName] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [openColorPicker, setOpenColorPicker] = useState(false);
  const MainColors = ["white", "red", "green", "yellow", "orange"];
  let defaultColor = furEditData?.color ? furEditData?.color : "#00FF00";
  const [color, setColor] = useColor(defaultColor);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const headersFormData = {
      "Content-Type": "multipart/form-data",
    };
    try {
      let formData = new FormData();
      formData.append("image", file);
      let res = await axios.post(
        `${import.meta.env.VITE_APP_BASE_URL}/api/image/upload`,
        formData,
        { headers: headersFormData }
      );
      setUrlData([{ imageUrl: res?.data?.data?.imageUrl }]);
      setImgName(res?.data?.data?.name);
    } catch (err) {
      console.log(err);
    }
  };

  const getCategoriesData = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    try {
      let res = await axios.get(
        `${import.meta.env.VITE_APP_BASE_URL}/api/furniture-category/get-list`,
        { headers: headersFormData }
      );
      setCategoryData(res?.data?.data);
    } catch (err) {
      console.log("get_category", err);
    }
  };

  const handleKeyPhone = (e) => {
    if (e.keyCode === 32) e.preventDefault();
  };

  const handleSubmit = async () => {
    debugger
    const {
      furnitureName,
      furnitureCat,
      furniturePrice,
      furnitureDes,
      furnitureBrand,
      furnitureMaterial,
      houseware_categories,
    } = inputData;

    if (
      !furnitureName ||
      !furnitureCat ||
      !furniturePrice ||
      !furnitureBrand ||
      !color ||
      !furnitureMaterial||
      !houseware_categories
    ) {
      setInputError(true);
      return;
    }

    const headerJson = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    const data = {
      name: furnitureName,
      price: furniturePrice,
      description: furnitureDes,
      furniture_category_id: furnitureCat,
      furniture_img: [urlData[0]?.imageUrl],
      color: color.hex,
      material: furnitureMaterial,
      brand: furnitureBrand,
      type: "houseware",
      houseware_categories:houseware_categories
    };

    try {
      setButtonLoader(true);
      const res = await axios.post(
        `${import.meta.env.VITE_APP_BASE_URL}/api/furniture/create`,
        data,
        { headers: headerJson }
      );
      if (res) {
        navigate("/user_dash/furniture_company/add_package", {
          state: { EditPackageId: packageId, categoryId, leasePeriod, categoryName },
        });
      }
    } catch (err) {
      console.log(err);
      setButtonLoader(false);
    }
  };

  const handleEditFurniture = async () => {
    const {
      furnitureName,
      furnitureCat,
      furniturePrice,
      furnitureDes,
      furnitureMaterial,
      furnitureBrand,
      houseware_categories,
    } = inputData;

    if (!furnitureName || !furnitureCat || !furniturePrice || !urlData?.length > 0) {
      setInputError(true);
      return;
    }

    const headerJson = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    const data = {
      name: furnitureName,
      price: furniturePrice,
      description: furnitureDes,
      furniture_category_id: furnitureCat,
      furniture_img: [urlData[0]?.imageUrl],
      color: color.hex,
      material: furnitureMaterial,
      brand: furnitureBrand,
      houseware_categories:houseware_categories,
    };

    try {
      setButtonLoader(true);
      const res = await axios.put(
        `${import.meta.env.VITE_APP_BASE_URL}/api/furniture/update/${furEditData?.id}`,
        data,
        { headers: headerJson }
      );
      if (res) {
        setButtonLoader(false);
        setInputData({
          furnitureName: "",
          furnitureCat: "",
          furniturePrice: "",
          furnitureDes: "",
          houseware_categories:"",
        });
        setUrlData([]);
        navigate("/user_dash/furniture_company/add_package", {
          state: { EditPackageId: packageId, categoryId, leasePeriod, categoryName },
        });
        setFurEditData("");
      }
    } catch (err) {
      console.log(err);
      setButtonLoader(false);
    }
  };

  useEffect(() => {
    getCategoriesData();
  }, [user?.token]);

  return (
    <Fragment>
      <div className="main-box">
        <div className="content-header">
          <h3>{furEditData ? "Edit Houseware" : "Add New Houseware"}</h3>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="editp_pet_field add_new_furnit_field">


              <div className="edit_inner_pet furnit_edit_pet">
                <div className="editp_pet_field_inner">
                  <div className="profile_field">
                    <label className="form-label">Enter Product Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter product name"
                      value={inputData.furnitureName}
                      onKeyPress={(e) => {
                        if (!/^[a-zA-Z \s]+$/.test(e.key)) e.preventDefault();
                      }}
                      onChange={(e) =>
                        setInputData({ ...inputData, furnitureName: e.target.value })
                      }
                    />
                    {inputError && !inputData.furnitureName && (
                      <div className="error">Please enter product name!</div>
                    )}
                  </div>

                  <div className="profile_field">
                    <label className="form-label">Product Category</label>
                    <select
                      className="form-control"
                      value={inputData.houseware_categories}
                      onChange={(e) =>
                        setInputData({ ...inputData, houseware_categories: e.target.value })
                      }
                    >
                      <option value="">Select Option</option>
                      <option value="LivingRoomItem">Living Room Item</option>
                      <option value="DinningRoom">Dinning Room</option>
                      <option value="Bedroom">Bedroom</option>
                      <option value="Bathroom">Bathroom</option>
                      <option value="Kitchen">Kitchen</option>
                      <option value="IronBoard">Iron Board</option>
                      <option value="CleaningBoard">Cleaning Board</option>
                      <option value="Vaccum">Vaccum</option>
                    </select>

                    {inputError && !inputData.houseware_categories && (
                      <div className="error">Please select your product category!</div>
                    )}
                  </div>

                  <div className="profile_field">
                    <label className="form-label">Product Price</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="$150"
                      onKeyDown={handleKeyPhone}
                      value={inputData.furniturePrice}
                      onKeyPress={(e) => {
                        if (!/(?:^| )\d+(\.\d+)?(?=$| )/.test(e.key)) e.preventDefault();
                      }}
                      onChange={(e) =>
                        setInputData({ ...inputData, furniturePrice: e.target.value })
                      }
                    />
                    {inputError && !inputData.furniturePrice && (
                      <div className="error">Please enter your product price!</div>
                    )}
                  </div>

                  <div className="profile_field">
                    <label className="form-label">Product Brand</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter product brand name"
                      value={inputData.furnitureBrand}
                      onKeyPress={(e) => {
                        if (!/^[a-zA-Z \s]+$/.test(e.key)) e.preventDefault();
                      }}
                      onChange={(e) =>
                        setInputData({ ...inputData, furnitureBrand: e.target.value })
                      }
                    />
                    {inputError && !inputData.furnitureBrand && (
                      <div className="error">Please enter your product brand name!</div>
                    )}
                  </div>

                  <div className="profile_field">
                    <label className="form-label">Product Material</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter product material"
                      value={inputData.furnitureMaterial}
                      onKeyPress={(e) => {
                        if (!/^[a-zA-Z \s]+$/.test(e.key)) e.preventDefault();
                      }}
                      onChange={(e) =>
                        setInputData({ ...inputData, furnitureMaterial: e.target.value })
                      }
                    />
                    {inputError && !inputData.furnitureMaterial && (
                      <div className="error">Please enter your product material!</div>
                    )}
                  </div>

                  <div className="profile_field">
                    <div className="frunit_color" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <div>
                        Product Color <span>(click to pick color)</span>
                      </div>
                      {openColorPicker ? (
                        <div className="col_picer">
                          <button type="button" onClick={() => setOpenColorPicker(false)}>
                            X
                          </button>
                          <ColorPicker
                            width={100}
                            height={100}
                            color={color}
                            onChange={setColor}
                            hideInput={["rgb", "hsv"]}
                          />
                        </div>
                      ) : (
                        <button
                          className="picker_opener"
                          type="button"
                          style={{ background: color?.hex }}
                          onClick={() => setOpenColorPicker(true)}
                        ></button>
                      )}
                    </div>
                  </div>

                </div>

                <div className="add_field add_new_furnit_desc_field">
                  <label className="form-label">Add Product Description</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Add Description"
                    value={inputData.furnitureDes}
                    onChange={(e) =>
                      setInputData({ ...inputData, furnitureDes: e.target.value })
                    }
                  />
                </div>

                <div className="sap_blue_btn">
                  {furEditData ? (
                    <Button isLoading={buttonLoader} onClick={() => handleEditFurniture()}>
                      Save Changes
                    </Button>
                  ) : (
                    <Button isLoading={buttonLoader} onClick={() => handleSubmit()}>
                      Save Details
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductForm;
